import Vue from "vue";
import App from "./App/App.vue";
import Home from "./Home.vue";
var vm = window.$vm = new Vue({
    name: "App",
    el: "app",
    components: {
        App: App,
        Home: Home
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/Home.cshtml.ts
// module id = 1273
// module chunks = 8